// The valuation itself lives beneath both sides (`shared/prices.ts`), because the
// price-tie policy in the session store has to compare exactly the number a row shows.
export { potentialPrice, type PotentialPrice } from "../shared/prices";

const formatters = {
  USD: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }),
  EUR: new Intl.NumberFormat("en-US", { style: "currency", currency: "EUR" }),
};

export function formatPrice(cents: number | null, currency: "USD" | "EUR" = "USD"): string {
  return cents === null ? "—" : formatters[currency].format(cents / 100);
}
